import { events, parseOrderForAnalytics } from '@waybetter/wb-analytics';

import { getCookie } from '../cookies.js';
import { logger } from '../logger';
import { DEFAULT_LTV } from '../../../server/quiz.calculateLtv.js';

import { appendGameUrl } from './append-game-url';

export const trackCompleteGameOrder = ({
  order,
  referringGameId,
  userId,
  geo,
}) => {
  order.orderItems = appendGameUrl(order.orderItems);

  const isMembershipOrder = order?.orderItems.find(
    (item) => item?.type === 'MembershipOrderItem'
  );

  const awinConversionObj = {
    transactionID: order.id,
    transactionCurrency: 'USD',
    transactionTotal: order.amountDue,
    transactionPromoCode: null,
    Source: getCookie('awin_channel') || getCookie('AwinChannelCookie'),
  };

  const conversionEvent = { event: 'Membership Trial Started' };

  dataLayer.push(awinConversionObj);
  dataLayer.push({ orderid: order.id.toString() });

  if (isMembershipOrder) {
    dataLayer.push(conversionEvent);
    dataLayer.push(geo);
  }

  const predicted_ltv = dataLayer.find((x) => x?.ltv)?.ltv;

  const analyticsOrder = parseOrderForAnalytics({
    user: { id: userId },
    order,
    appName: 'hub',
    referringGameId,
    decamelize: true,
  });

  // This needs to be called in the screen after the one where the order
  // completion was initialized, such as a confirmation screen. Therefore,
  // a callback is returned which must be called in the proper place.
  const callback = () => {
    try {
      analytics.track(events.ORDER_COMPLETED, {
        ...analyticsOrder,
        currency: 'USD',
        revenue: !analyticsOrder?.products[0]?.sku.includes('waybetter')
          ? analyticsOrder?.products[0]?.price
          : parseInt(predicted_ltv || DEFAULT_LTV),
      });

      if (isMembershipOrder) {
        analytics.track('Membership Trial Started', {
          order_id: order.id,
          order_item_id: analyticsOrder?.products[0]?.order_item_id,
          user_id: order.userId,
          predicted_ltv: predicted_ltv || DEFAULT_LTV,
          currency: 'USD',
        });
      }

      if (order.isFirstPaidOrder)
        analytics.track(events.FIRST_PAID_ORDER, analyticsOrder);
    } catch (error) {
      logger.error("Unable to send 'Order Completed' event", error);
    }
  };

  return callback;
};
